import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MmDialogData, MmDialogRefService } from '@metromarkets/components';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import * as fromReturns from '../../../store/returns';
import { OrderHistoryItem } from '../../../models';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { METRO_ID_ORGANIZATION } from '~shared/constants/metro-seller.constant';
import { CountryCode, FeatureToggleEnum } from '~shared/constants';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

interface DataInput {
  order: OrderHistoryItem;
  title: string;
}
@Component({
  selector: 'app-return-products-dialog',
  templateUrl: './return-products-dialog.component.html',
  styleUrls: ['./return-products-dialog.component.scss']
})
export class ReturnProductsDialogComponent implements OnInit {

  public returnReasonControl: FormControl;
  public title: string;
  public order: OrderHistoryItem;
  public returnReasons$: Observable<any[]>;
  public showRefundFeeDisclaimer$ = this.featureFlagService.isFeatureEnabledForCurrentCountry$(FeatureToggleEnum.FF_TMP_ODR_1536_SHOW_REFUND_FEE_IN_OHP)

  public readonly metroIdOrganization = METRO_ID_ORGANIZATION;

  public faqUrl = '';
  
  public faqUrlByCountry = {
    [CountryCode.Germany] : 'https://metro-markets.freshdesk.com/de/support/solutions/articles/75000019041-fallen-f%C3%BCr-die-r%C3%BCcksendung-nach-aus%C3%BCbung-des-widerrufsrechts-kosten-f%C3%BCr-mich-an-',
    [CountryCode.Spain] : 'https://support-es.metro-marketplace.eu/es/support/solutions/articles/75000125409-%C2%BFtendr%C3%A9-que-pagar-el-env%C3%ADo-de-la-devoluci%C3%B3n-si-ejerzo-mi-derecho-de-desistimiento-',
    [CountryCode.Italy] : 'https://support-it.metro-marketplace.eu/it/support/solutions/articles/75000086439-in-caso-di-restituzione-sussistono-costi-a-mio-carico-',
    [CountryCode.Portugal] : 'https://support-pt.metro-marketplace.eu/pt-PT/support/solutions/articles/75000125900-terei-de-pagar-o-envio-da-devolu%C3%A7%C3%A3o-depois-de-exercer-o-meu-direito-de-rescis%C3%A3o-/',
    [CountryCode.Netherlands] : 'https://support-nl.metro-marketplace.eu/nl/support/solutions/articles/103000051712-maak-ik-kosten-als-ik-de-goederen-retourneer-',
    [CountryCode.France] : 'https://support-fr.metro-marketplace.eu/fr/support/solutions/articles/103000132844-est-ce-que-je-vais-avoir-des-frais-si-je-retourne-la-marchandise-',
  };

  constructor(private store: Store<fromReturns.State>,
              private dialogRefService: MmDialogRefService<ReturnProductsDialogComponent>,
              @Inject(MmDialogData) private data: DataInput,
              private readonly featureFlagService: ActiveFeaturesConfigcatService,
              @Optional() @Inject(REQUEST) private webAppBuyerRequest: any
            ) {
    this.title = this.data && this.data.title;
    this.order = this.data && this.data.order;
    this.returnReasonControl = new FormControl('', [Validators.required]);
  }

  get isMetroInOrder(): boolean {
    return this.order?.orderLines.some((orderLine) => orderLine?.seller?.id === this.metroIdOrganization) ?? false;
  }

  ngOnInit(): void {
    this.store.dispatch(new fromReturns.ReadReturnsReasons());
    this.returnReasons$ = this.store.pipe(
      select(fromReturns.getOrdersReturnReasons), publishReplay(1), refCount());
    this.faqUrl = this.faqUrlByCountry[getCountryDomainCode(this.webAppBuyerRequest)]
  }

  onConfirm() {
    this.returnReasonControl.markAsDirty();
    if (this.returnReasonControl.valid) {
      this.dialogRefService.close({ reason: this.returnReasonControl.value.value });
    }
  }
}
